// RITA-1538 (Entscheidung Julia 12.10.2026, Variante B): Lehnt der Server einen Abruf der
// geschützten Dateien (/files, /accounting) mit 401 ab, ist die Anmeldung abgelaufen (das Token
// gilt 10 Stunden). Statt stummem Schließen bzw. technischer Fehlermeldung erscheint dieser
// Hinweis als übliche Meldung; es wird nichts automatisch abgemeldet oder umgeleitet.
export const ANMELDUNG_ABGELAUFEN_HINWEIS = 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich neu an.';

export const istAnmeldungAbgelaufen = (status: unknown): boolean => status === 401;
